import React, { useMemo } from "react";
import { AsyncPaginate } from "react-select-async-paginate";
import { useNavigate } from 'react-router-dom';
import "../../styles/Auth/store.css";

const sanitizeValue = (val) => {
    if (!Array.isArray(val)) return [];
    return val.filter(
        v =>
            v &&
            typeof v === "object" &&
            v.value !== undefined &&
            v.label !== undefined &&
            v.label !== ""
    );
};

const StoreMultiSelect = ({
    value,
    onChange,
    loadStores,
    loggedInRole,
    assignedStoreIds = [],
    onAddStore,
    isDisabled = false
}) => {
    const safeValue = useMemo(() => sanitizeValue(value), [value]);

    return (
        <AsyncPaginate
            isMulti
            isDisabled={isDisabled}
            value={safeValue}
            placeholder="Select Stores"
            additional={{ page: 1 }}
            inputId="store-select-input"
            autoComplete="new-password"
            loadOptions={async (search, loadedOptions, additional) => {
                const res = await loadStores(search, loadedOptions, additional);
                let options = res?.options || [];

                // 🔒 Restrict ONLY non-admin roles
                if (
                    loggedInRole !== "SuperAdmin" &&
                    loggedInRole !== "SelfAdmin" &&
                    loggedInRole !== "StoreCreator"
                ) {
                    options = options.filter(o =>
                        assignedStoreIds.includes(o.value)
                    );
                }

                // ➕ Add Store for SuperAdmin, SelfAdmin & StoreCreator.
                // Only on the first page (nothing loaded yet), so it stays
                // pinned at the top and isn't repeated when more stores load.
                const alreadyAdded = (loadedOptions || []).some(o => o.value === "__ADD_STORE__");
                if (
                    onAddStore &&
                    (loggedInRole === "SuperAdmin" ||
                        loggedInRole === "SelfAdmin" ||
                        loggedInRole === "StoreCreator") &&
                    !alreadyAdded
                ) {
                    options = [
                        { value: "__ADD_STORE__", label: "+ Add Store" },
                        ...options.filter(o => o.value !== "__ADD_STORE__")
                    ];
                }

                return {
                    ...res,
                    options
                };
            }}
            onChange={(val) => {
                if (val?.some(v => v.value === "__ADD_STORE__")) {
                    onAddStore(); // 🔥 open add-store modal
                    return;
                }
                onChange(sanitizeValue(val));
            }}
        />
    );
};

export default StoreMultiSelect;
